import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-sms-list',
  templateUrl: './sms-list.component.html',
  styleUrls: ['./sms-list.component.scss']
})
export class SmsListComponent implements OnInit {
  public sms_list: any[] = [];
  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    let y:any = await this.http.post("/admin/company/sms/list")
    this.sms_list = y;
  }
}
